export const DEFAULT_COLORS = {
  pageBackground: "#FFF5E6",
  profileCard: "#CBEAFE",
  titleColor: "#000000",
  ctaColor: "#0D41E1",
  textColor: "#1E40FF",
};
